import { UploadProfilePictureResponseContent } from "@equaliq/api-model-v2";
import { 
  createApiRequest, 
  createApiResponse,
  PresignedUrlResponse,
  ApiResponse
} from "../common";
import { uploadFileWithPresignedUrl } from "../external-api/s3";

export const uploadProfilePictureApi = async (
  file: File
): Promise<ApiResponse<{ key: string }>> => {
  const request = createApiRequest<UploadProfilePictureResponseContent>('post', '/uploadProfilePicture');
  
  const presignedUrlResponse = await request({});

  if (!presignedUrlResponse.urlInfo) {
    throw new Error('Invalid Response: No Presigned URL info');
  }

  const fileKey = await uploadFileWithPresignedUrl(file, {
    url: presignedUrlResponse.urlInfo.url,
    fields: presignedUrlResponse.urlInfo.fields as Record<string, string>,
  } as PresignedUrlResponse);

  return createApiResponse(true, { key: fileKey });
};